import { SupportedLanguages, SupportedLocaleNumber } from "../enums/locale.enum";

export function normalizeCountryValue(value?: string | null): string {
    if (!value) return '';
    return value
        .toString()
        .trim()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toUpperCase();
}

const TAIWAN_ALIASES: ReadonlySet<string> = new Set([
    'TW', 'TWN', 'TAIWAN', 'REPUBLIC OF CHINA', 'TAIWAN PROVINCE OF CHINA', 'TAIWAN ROC'
]);

const PORTUGAL_ALIASES: ReadonlySet<string> = new Set([
    'PT', 'PRT', 'PORTUGAL', 'PORTUGUESE REPUBLIC'
]);

export function isTaiwanCountry(value?: string | null): boolean {
    const normalized = normalizeCountryValue(value);
    if (!normalized) return false;

    if (TAIWAN_ALIASES.has(normalized)) {
        return true;
    }

    const normalizedTokens = normalized
        .replace(/[\._\-\/,()]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .split(' ');

    return normalizedTokens.includes('TAIWAN') || normalizedTokens.includes('TW');
}

export function isPortugalCountry(value?: string | null): boolean {
    const normalized = normalizeCountryValue(value);
    if (!normalized) return false;

    if (PORTUGAL_ALIASES.has(normalized)) {
        return true;
    }

    const normalizedTokens = normalized
        .replace(/[\._\-\/,()]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .split(' ');

    return normalizedTokens.includes('PORTUGAL') || normalizedTokens.includes('PT');
}

export function languageToLocaleEmail(language?: string | null): SupportedLocaleNumber {
    const supportedLanguage = language?.toUpperCase()

    switch (supportedLanguage) {
        case SupportedLanguages.ES:
        case SupportedLanguages["ES-CL"]:
            return SupportedLocaleNumber.ES;
        case SupportedLanguages.FR:
            return SupportedLocaleNumber.FR;
        case SupportedLanguages.EN:
            return SupportedLocaleNumber.EN;
        case SupportedLanguages.PT:
            return SupportedLocaleNumber.PT;
        case SupportedLanguages.CHT:
            return SupportedLocaleNumber.ZH;
        default:
            return SupportedLocaleNumber.EN;
    }
}
